import { FC, useCallback, useState } from "react";
import { createContext } from "use-context-selector";
import styled from "styled-components";
import logo from "../assets/loading_logo.gif";

const FullPageLoadingWrapper = styled("div")`
  background-color: rgba(0, 0, 0, 0.7) !important;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export type FullPageLoadingContextType = {
  handleShowFullPageLoading: (value: boolean) => void;
};

export const FullPageLoadingContext = createContext(
  {} as FullPageLoadingContextType
);

export const FullPageLoadingContextProvider= ({ children }: { children: any }) => {
  const [show, setShow] = useState<boolean>(false);

  /**
   * @param {boolean} value Estado desejado do loading, true para exibir e false para esconder
   */
  const handleShowFullPageLoading = useCallback((value: boolean) => {
    setShow(value);
  }, []);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FullPageLoadingContext.Provider
      value={{
        handleShowFullPageLoading,
      }}
    >
      {show && (
        <FullPageLoadingWrapper>
          <img height={120} src={logo} />
        </FullPageLoadingWrapper>
      )}
      {children}
    </FullPageLoadingContext.Provider>
  );
};
